import { useParams, Link } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import { fetchUserById, reinviteUser } from "@/lib/api/resources/users";
import { Descriptions } from "@/components/v2";
import { Button, Card } from "@rumbledirect/ui";
import { Space, message, type DescriptionsProps } from "antd";
import { format, parseISO } from "date-fns";
import { EditOutlined } from "@ant-design/icons";

export const UserDetail = () => {
  const { id } = useParams();

  if (!id) return null;

  const userQuery = useQuery({
    queryKey: ["user", id],
    queryFn: () => fetchUserById(id),
  });

  const reinviteUserMutation = useMutation({
    mutationFn: () => reinviteUser(id),
    onSuccess: () => {
      message.success("Gebruiker succesvol opnieuw uitgenodigd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het uitnodigen van de gebruiker",
      ),
  });

  return (
    <Card
      loading={userQuery.isLoading}
      title="Gebruiker"
      extra={
        <Space>
          <Link to={`/users/${id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
        </Space>
      }
      className="max-w-3xl"
    >
      {(() => {
        const items: DescriptionsProps["items"] = [
          { label: "Naam", children: userQuery?.data?.fullName ?? null },
          { label: "E-mail", children: userQuery?.data?.email ?? null },
          { label: "Rol", children: userQuery?.data?.role?.name ?? null },
          {
            label: "Dealer",
            children: userQuery?.data?.dealershipCompany?.fullName ?? null,
          },
          {
            label: "Meest recente activiteit",
            children: (
              <>
                {userQuery?.data?.lastActivity
                  ? format(
                      parseISO(userQuery?.data?.lastActivity),
                      "dd MMMM yyyy HH:mm",
                    )
                  : "Nooit"}

                {userQuery?.data?.existsInKeycloak === false ? (
                  <Button
                    className="ml-4"
                    type="primary"
                    loading={reinviteUserMutation.isPending}
                    onClick={() => reinviteUserMutation.mutate()}
                  >
                    Opnieuw uitnodigen
                  </Button>
                ) : null}
              </>
            ),
          },
        ];
        return <Descriptions items={items} />;
      })()}
    </Card>
  );
};
